import { RefObject, useCallback, useEffect, useState } from 'react';

import { useIsOverflowing } from './useIsOverflowing';
import { useScrollHandler } from './useScrollHandler';

export const useScrollIndicator = (scrollParentRef: RefObject<HTMLDivElement>) => {
  const [scrolled, setScrolled] = useState(false);
  const registerScroll = useCallback(() => {
    setScrolled(true);
  }, []);

  useEffect(() => {
    setScrolled(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrollParentRef.current]);

  useScrollHandler(scrollParentRef, registerScroll);
  const { isOverflowing, isOverflowingMeasurer } = useIsOverflowing();

  const showScrollIndicator = isOverflowing && !scrolled;

  return { isOverflowingMeasurer, showScrollIndicator };
};
